import React, { useState, useEffect } from "react";
import {
  Spinner,
  Button,
  Form,
  Col,
  Row,
  FloatingLabel,
  Modal
} from "react-bootstrap";

import {
  getAllContent,
  getContentById,
  postContent,
  updateContent,
  deleteContentById
} from "../../services/content/content-service.js";
import ContentsEditForm from "./widgets/ContentsEditForm";
import { useQueryClient, useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";

function ContentEditFormModal({ contentData, ...props }) {
  const queryClient = useQueryClient();
  const [validationErrors, setValidationErrors] = useState([]);

  const editContentMutation = useMutation({
    mutationFn: (variables) => updateContent(contentData?.id, variables),
    onSuccess: () => {
      queryClient.resetQueries(["content"]);
      props.onClose();
      toast.success("Content Updated Successfully");
    },
    onError: (error) => {
      if (error.response) {
        const errorData = error.response.data;
        console.log("Validation errors:", errorData);

        const testvalidationErrors = Object.entries(errorData).map(
          ([key, value]) => ({
            key,
            value: value.join(", ") // Convert the array of error messages to a string
          })
        );

        setValidationErrors(testvalidationErrors);

        // Create the alert message
        const alertMessage = (
          <ul>
            {testvalidationErrors.map((error, index) => (
              <li key={index}>
                {error.key} : {error.value}
              </li>
            ))}
          </ul>
        );

        // Show the alert using your preferred alert mechanism (e.g., toast)
        toast.warning(alertMessage);
      } else {
        toast.error(
          "There was an error updating content ! please contact the administrator"
        );
      }
    }
  });

  const handleSubmit = (event, data) => {
    console.log(data);
    event.preventDefault();
    setValidationErrors([]);

    editContentMutation.mutate(data);

    // toast.warning("check your capital current ratio");
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Content Edit Form
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {validationErrors.length > 0 && (
          <div className="alert alert-danger">
            <ul>
              {validationErrors.map((error, index) => (
                <li key={index}>
                  {error.key} : {error.value}
                </li>
              ))}
            </ul>
          </div>
        )}
        <p>Fill in the form below</p>

        <ContentsEditForm
          contentData={contentData}
          handleSubmit={handleSubmit}
        />
        {/* <p>{editProjectsMutation.status}</p> */}
        {editContentMutation.isLoading && (
          <center>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </center>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default ContentEditFormModal;
